import React, { useEffect, useState } from "react";
import "../../Styles/yellowcalfcss/ViewBank.css";
import { useNavigate, useParams } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import ConfirmModal from "../../components/ConfirmModal";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";

const BankView = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  /* ---------------- STATE ---------------- */
  const [bankData, setBankData] = useState(null);
  const [loading, setLoading] = useState(false);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  /* ---------------- VIEW API ---------------- */
  const fetchBankDetails = async () => {
    setLoading(true);

    const body = {
      customer_id: Number(localStorage.getItem("customer_id")),
      api_key: localStorage.getItem("api_key"),
      user_id: Number(localStorage.getItem("user_id")),
      language: "en",
      id: Number(id),
    };

    try {
      const res = await simplePostCall(
        ApiConfig.bankView,
        JSON.stringify(body)
      );

      if (res?.result && res.data?.length) {
        setBankData(res.data[0]);
      } else {
        toast.error("Bank details not found");
      }
    } catch {
      toast.error("Network error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBankDetails();
  }, [id]);

  /* ---------------- DELETE API ---------------- */
  const handleDeleteBank = async () => {
    setIsDeleting(true);

    const body = {
      customer_id: Number(localStorage.getItem("customer_id")),
      api_key: localStorage.getItem("api_key"),
      user_id: Number(localStorage.getItem("user_id")),
      language: "en",
      id: Number(id),
    };

    try {
      const res = await simplePostCall(
        ApiConfig.bankDelete,
        JSON.stringify(body)
      );

      if (res?.result) {
        toast.success(res.message);
        navigate("/accountant/BankType");
      } else {
        toast.error(res?.message || "Delete failed");
      }
    } catch {
      toast.error("Network error");
    } finally {
      setIsDeleting(false);
      setShowDeleteModal(false);
    }
  };

  /* ---------------- UI ---------------- */
  return (
    <>
      <div className="expenses-view-bill-1-header-row">
        <h1 className="expenses-view-bill-1-page-title">Bank Information</h1>

        <div className="expenses-view-bill-1-header-actions">
          <button
            className="expenses-view-bill-1-btn expenses-view-bill-1-btn-edit"
            onClick={() => navigate(`/accountant/EditBank/${id}`)}
          >
            Edit
          </button>

          <button
            className="expenses-view-bill-1-btn expenses-view-bill-1-btn-delete"
            onClick={() => setShowDeleteModal(true)}
          >
            Delete
          </button>
        </div>
      </div>

      <div className="BankView-container">
        <div className="BankView-card">
          {loading ? (
            <div className="text-center py-5">
              <Spinner />
            </div>
          ) : bankData ? (
            <div className="BankView-row">
              <div className="BankView-col BankView-borderRight">
                <h6 className="BankView-title">Bank Information</h6>

                <div className="BankView-item">
                  <span className="BankView-label">Bank Name:</span>
                  <span className="BankView-value BankView-highlight">
                    {bankData.bank_name || "-"}
                  </span>
                </div>

                <div className="BankView-item">
                  <span className="BankView-label">Branch:</span>
                  <span className="BankView-value">
                    {bankData.bank_branch || "-"}
                  </span>
                </div>

                <div className="BankView-item">
                  <span className="BankView-label">
                    Swift Code/IBAN/IFSC:
                  </span>
                  <span className="BankView-value">
                    {bankData.bank_swift_code || "-"}
                  </span>
                </div>
              </div>

              <div className="BankView-col">
                <h6 className="BankView-title">Account Information</h6>

                <div className="BankView-item">
                  <span className="BankView-label">
                    Account Holder Name:
                  </span>
                  <span className="BankView-value">
                    {bankData.bank_account_holder_name || "-"}
                  </span>
                </div>

                <div className="BankView-item">
                  <span className="BankView-label">Account Number:</span>
                  <span className="BankView-value">
                    {bankData.bank_account_number || "-"}
                  </span>
                </div>
              </div>
            </div>
          ) : (
            <div className="text-center py-4">No data found</div>
          )}
        </div>
      </div>

      {/* DELETE CONFIRM MODAL */}
      <ConfirmModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        title="Delete Bank"
        message="Are you sure you want to delete this bank record?"
        confirmText="Delete"
        confirmVariant="danger"
        onConfirm={handleDeleteBank}
        isLoading={isDeleting}
      />
    </>
  );
};

export default BankView;
